import React, { useMemo } from 'react'

import { ReserveForm } from '@/app/[locale]/shared'
import { locations } from '@/constants'
import { useLanguages } from '@/hooks'
import { homePath } from '@/utils'
import { redirect } from '@/i18n'

interface IFormProps {
  title: string
  location: string
}

export const Form: React.FC<IFormProps> = ({ location, title }) => {
  const { appLang } = useLanguages()
  // @ts-ignore
  const locationDetails = useMemo(() => locations[location], [location])

  if (!locationDetails) {
    redirect({
      href: homePath,
      locale: appLang,
    })
  }

  return (
    <React.Fragment>
      <div className="cover">
        <h1 className="blue-color">{title}</h1>
        <div></div>
      </div>
      <section className="reservation theme--light-blue">
        <div className="row">
          <ReserveForm pickupDetails={locationDetails} />
        </div>
      </section>
    </React.Fragment>
  )
}
